import styles from "./CadastroJanelas.module.scss";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  Link,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import InfoIcon from '@mui/icons-material/Info';
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import logo from "../../../assets/janelas/logo_janelas.png";
import logo from "../../../assets/logo-horiz-movimento.gif";
import regua from "../../../assets/janelas/regua_de_logos.png";
import InputMask from "react-input-mask";
import { useEffect, useRef, useState } from "react";
import { validaCpf, validaData } from "../../../components/validacoes";
import { Toast } from "../../../services/Swal";
import ESCOLAS_ALUNO from "./escolas/Aluno.json";
import ESCOLAS_MEE from "./escolas/MEE.json";
import HelmetThemeColor from "../../../components/HelmetThemeColor/HelmetThemeColor";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import Widget, { setWidgetIsOpen } from "../../../components/Widget/Widget";
import { InputArea } from "../../../components/Box/Box";
import { Input } from "../../../components/Input/Input";
import { ContainedBtn } from "../../../components/ButtonTypes/Button";

const lightTheme = createTheme({
  palette: {
    background: {
      default: "#ffffff",
    },
    primary: {
      main: "#008542",
    },
    secondary: {
      main: "#FDC82F",
    },
  },
});

const box = {
  paddingY: 1,
  display: "flex",
  flexDirection: "column",
  // // alignItems: "center",
  // // border: "1px solid black"
};

const iconsList = { paddingTop: 1, color: "primary.main" };

const horarios = [
  "Terça - Noite (19h às 21h)",
  "Quarta - Noite (19h às 21h)",
  "Quinta - Noite (19h às 21h)",
  "Sábado - Manhã (10h às 12h)",
];

function ChipDivider({ label, color = "primary" }) {
  return (
    <Grid item xs={12}>
      <Divider>
        <Chip label={label} color={color} />
      </Divider>
    </Grid>
  );
}

export default function CadastroJanelas() {
  const [form, setForm] = useState({
    perfil: "",
    dadosPessoais: {
      nomeCompleto: "",
      nomeSocialCompleto: "",
      usoNomeSocial: false,
      nacionalidade: "",
      cpf: "",
      documentoDeIdentifcacao: "",
      nacionalidadeOutro: "",
      dataNascimento: "",
      email: "",
      telefone: "",
      whatsapp: false,
      senha: "",
      confirmacaoSenha: "",
      dadosDoResponsavel: {
        nomeCompleto: "",
        grauDeParentesco: "",
        qualGrauDeParentesco: "",
        cpf: "",
      },
      endereco: {
        cep: "",
        estado: "",
        cidade: "",
        bairro: "",
        rua: "",
        numero: "",
        complemento: "",
      },
    },
    dadosSociodemograficos: {
      genero: "",
      generoOutro: "",
      raca: "",
      racaOutro: "",
      lgbt: "",
      deficiencia: "",
      refugiado: "",
      indigena: "",
      comunidadeTradicional: "",
      comunidadeResidencia: "",
    },
    escola: {
      estado: "",
      municipio: "",
      nomeDaEscola: "",
      nomeDoProfessor: "",
      nomeDoProfessorOutro: "",
    },
    funcaoNaEscola: {
      funcao: "",
      funcaoOutro: "",
      quantidadeTurmas: 0,
      ministraAulas: [],
    },
    inscricao: {
      qualOportunidade: "",
      melhorHorario: "",
      melhorHorarioAlternativo: "",
    },
    termos: [],
  });

  const [loading, setLoading] = useState(false);
  const [termos, setTermos] = useState([{}]);

  const [estados, setEstados] = useState();
  const [estadosEscolas, setEstadosEscolas] = useState();
  const [cidades, setCidades] = useState();

  const [municipios, setMunicipios] = useState([]);
  const [escolas, setEscolas] = useState([]);

  const [professores, setProfessores] = useState([]);

  const [showPassword, setShowPassword] = useState(false);
  const [idade, setIdade] = useState();
  const [open, setOpen] = useState(false);

  const sectionRef = useRef();
  const [semNumero, setSemNumero] = useState(false);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_ESTADO)
      .then((response) => response.json())
      .then((data) => setEstados(data));
  }, []);
  
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_ESCOLAS}/estados`)
      .then((response) => response.json())
      .then((data) => setEstadosEscolas(data));
  }, []);

useEffect(() => {
  if (form.escola.estado) {
    fetch(
      `${process.env.REACT_APP_API_ESCOLAS}/municipios/${form.escola.estado}`
    )
      .then((response) => response.json())
      .then((data) => setMunicipios(data));
  }
}, [form.escola.estado]);

useEffect(() => {
  if (form.escola.municipio) {
    fetch(
      `${process.env.REACT_APP_API_ESCOLAS}/escolas/${form.escola.estado}/${form.escola.municipio}`
    )
      .then((response) => response.json())
      .then((data) => setEscolas(data));
  }
}, [form.escola.estado, form.escola.municipio]);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_ESTADO}/${form.dadosPessoais.endereco.estado}/municipios`
    )
      .then((response) => response.json())
      .then((data) => setCidades(data));
  }, [form.dadosPessoais.endereco.estado]);

  // useEffect(() => {
  //   let FILE = form.perfil === "MEE" ? ESCOLAS_MEE : ESCOLAS_ALUNO;

  //   function filtrarPorUF(uf) {
  //     return FILE.filter((escola) => escola.UF === uf)
  //       .map((escola) => escola.Municipio)
  //       .filter((municipio, index, self) => self.indexOf(municipio) === index)
  //       .map((municipio) => ({ label: municipio }));
  //   }

  //   const filtradas = filtrarPorUF(form?.escola.estado);
  //   setMunicipios(filtradas);
  // }, [form?.escola.estado, form.perfil]);

  // useEffect(() => {
  //   let FILE = form.perfil === "MEE" ? ESCOLAS_MEE : ESCOLAS_ALUNO;

  //   function filtrarPorMunicipio(municipio) {
  //     return FILE.filter((escola) => escola.Municipio === municipio)
  //       .map((escola) => escola.Escola)
  //       .filter((escola, index, self) => self.indexOf(escola) === index)
  //       .map((escola) => ({ label: escola }));
  //   }

  //   const filtradas = filtrarPorMunicipio(form?.escola.municipio);
  //   setEscolas(filtradas);
  // }, [form?.escola.municipio, form.perfil]);

  useEffect(() => {
    if (form?.escola.nomeDaEscola)
      fetch(
        `${process.env.REACT_APP_BACKEND}/api/Janelas/GetProfessores?nomeEscola=${form?.escola.nomeDaEscola}`
      )
        .then((response) => response.json())
        .then((data) => setProfessores(data.payload));
  }, [form?.escola.nomeDaEscola]);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/GetTermos/Cadastro?projeto=Janelas`
    )
      .then((response) => response.json())
      .then((data) => setTermos(data.payload));
  }, []);

  const termosParaEnviar = (termos) => {
    const termosEnviar = [];
    Object.keys(termos).map((termo) => {
      return termosEnviar.push({
        nome: termo,
        aceite: termos[termo],
      });
    });
    return termosEnviar;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const checkCep = async (e) => {
    const cep = e.target.value;
    if (!cep) return;
    await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((cep) => {
        if (cep.erro) {
          Toast.fire({
            icon: "info",
            title: "CEP não localizado",
          });
        } else {
          setForm({
            ...form,
            dadosPessoais: {
              ...form.dadosPessoais,
              endereco: {
                ...form.dadosPessoais.endereco,
                estado: cep.uf,
                cidade: cep.localidade,
                rua: cep.logradouro,
                bairro: cep.bairro,
                complemento: cep.complemento,
              },
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);

        setForm({
          ...form,
          dadosPessoais: {
            ...form.dadosPessoais,
            endereco: {
              ...form.dadosPessoais.endereco,
              cep: "",
              estado: "",
              cidade: "",
              rua: "",
              bairro: "",
              complemento: "",
            },
          },
        });
        Toast.fire({
          icon: "error",
          title: "CEP inválido",
        });
      });
  };

  const contemElemento = (array1, array2) => {
    for (let i = 0; i < array1.length; i++) {
      if (array2.includes(array1[i])) {
        return true;
      }
    }
    return false;
  };

  function checkSenha(password) {
    if (!password) return;
    const pattern = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g;

    if (!pattern.test(password)) {
      Toast.fire({
        icon: "error",
        title:
          "A senha deverá conter no mínimo oito dígitos, ao menos um número, uma letra maiúscula e um caractere especial.",
      });
      setForm({
        ...form,
        dadosPessoais: { ...form.dadosPessoais, senha: "" },
      });
    }
  }

  function validaSenha(senha, confirmaSenha) {
    if (senha !== confirmaSenha) {
      Toast.fire({
        icon: "error",
        title: "Confirmação de senha inválida",
      });
      setForm({
        ...form,
        dadosPessoais: { ...form.dadosPessoais, confirmacaoSenha: "" },
      });
    }
  }

  function handleDataNascimento(data) {
    if (!data) return;

    if (validaData(data) === false) {
      setForm({
        ...form,
        dadosPessoais: { ...form.dadosPessoais, dataNascimento: "" },
      });
      setIdade(null);
      Toast.fire({ icon: "error", title: "Data inválida" });
      return;
    }

    let idade = validaData(data);
    setIdade(idade);

    if (!(idade > 0) || !(idade < 100)) {
      setForm({
        ...form,
        dadosPessoais: { ...form.dadosPessoais, dataNascimento: "" },
      });
      setIdade(null);
      Toast.fire({
        icon: "error",
        title: "A idade precisa ser maior que 0 anos e menor que 100 anos",
      });
      return;
    }
  }

  function handleCPF(cpf) {
    if (!cpf) return;
    if (!validaCpf(cpf)) {
      setForm({
        ...form,
        dadosPessoais: { ...form.dadosPessoais, cpf: "" },
      });
      Toast.fire({
        icon: "error",
        title: "CPF inválido",
      });
    }
  }

  const header = (
    <>
      <img src={logo} alt="logo" style={{ maxWidth: "250px" }} />

      {/* <Typography component="h1" variant="h5">
        Olá, seja bem-vindo(a)!
      </Typography> */}

      <Box sx={{ width: "100%", marginTop: 6 }}>
        <ChipDivider label="Contato" />

        <Typography component="h1" variant="body1">
          <EmailIcon sx={iconsList} /> E-mail:{" "}
          <Link
            to="#"
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              window.open("mailto:escolas@recode.org.br");
              e.preventDefault();
            }}
          >
            {" "}
            escolas@recode.org.br
          </Link>
        </Typography>

        <Typography component="h1" variant="body1">
          <WhatsAppIcon sx={iconsList} /> WhatsApp:{" "}
          <Link
            to="#"
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              window.open("https://wa.me/5511982385998", "_blank");
              e.preventDefault();
            }}
          >
            {" "}
            (11) 98238-5998
          </Link>
        </Typography>

        {/* <Typography component="h1" variant="body1">
        <InfoIcon sx={iconsList} /> Para mais informações, clique <Link
          to='#'
          sx={{ cursor: "pointer" }}
          onClick={(e) => {
            window.open("http://bit.ly/FormacaoJanelas", '_blank')
            e.preventDefault();
          }}
        > aqui</Link>.
      </Typography> */}
      </Box>
    </>
  );

  const inicio = (
    <>
      <ChipDivider label="Início" />

      <FormControl>
        <FormLabel>Eu sou...</FormLabel>
        <RadioGroup
          row
          onChange={async (e) => {
            await setForm({ ...form, perfil: e.target.value });
            sectionRef.current.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <FormControlLabel
            value="Aluno"
            control={<Radio />}
            label="Aluno de Ensino Médio"
          />
          <FormControlLabel
            value="MEE"
            control={<Radio />}
            label="Membro da Equipe Escolar"
          />
        </RadioGroup>
      </FormControl>

      {form?.perfil === "MEE" && (
        <>
          <Typography
            component="h1"
            variant="h5"
            sx={{ paddingY: 2 }}
            ref={sectionRef}
          >
            Bem-vindo(a)!
          </Typography>

          <Typography component="h1" variant="subtitle1" sx={{ paddingY: 1 }}>
            Através deste cadastro, você poderá inscrever-se para a formação "O
            Papel dos Games na Aprendizagem" (para quaisquer membros da equipe
            escolar). Vamos lá?
          </Typography>
        </>
      )}

      {form?.perfil === "Aluno" && (
        <>
          <Typography
            component="h1"
            variant="h5"
            sx={{ paddingY: 2 }}
            ref={sectionRef}
          >
            Bem-vindo(a)!
          </Typography>

          <Typography component="h1" variant="subtitle1" sx={{ paddingY: 1 }}>
            Aluno(a) de Ensino Médio! Ao completar este cadastro, você estará
            automaticamente inscrito(a) na trilha "Reprogramando Seu Futuro".
            Vamos lá?
          </Typography>
        </>
      )}
    </>
  );

  const dadosPessoais = (
    <>
      <Grid container spacing={2}>
        <ChipDivider label="Dados pessoais" />

        <Grid item xs={12}>
          <TextField
            autoComplete="xablaw"
            required
            fullWidth
            label="Nome completo"
            inputProps={{ maxLength: 200 }}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  nomeCompleto: e.target.value,
                },
              })
            }
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            autoComplete="xablaw"
            fullWidth
            required={form.dadosPessoais.usoNomeSocial}
            label="Nome social completo"
            inputProps={{ maxLength: 200 }}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  nomeSocialCompleto: e.target.value,
                },
              })
            }
          />
        </Grid>

        <Grid item xs={12}>
          <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
            Preencha o campo acima somente se utilizar um nome diferente do que
            consta em seu documento de identificação. Do contrário, deixe em
            branco. Por favor, NÃO insira apelidos ou abreviações do seu nome de
            registro. Nome social é a designação pela qual a pessoa travesti ou
            transexual se identifica e é socialmente reconhecida (DECRETO Nº
            8.727, DE 28 DE ABRIL DE 2016).
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            label="Desejo utilizar meu nome social na plataforma e na emissão de certifcados"
            control={
              <Switch
                onChange={(e) =>
                  setForm({
                    ...form,
                    dadosPessoais: {
                      ...form.dadosPessoais,
                      usoNomeSocial: e.target.checked,
                    },
                  })
                }
              />
            }
          />
        </Grid>

        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Nacionalidade</FormLabel>
            <RadioGroup
              row
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosPessoais: {
                    ...form.dadosPessoais,
                    nacionalidade: e.target.value,
                  },
                })
              }
            >
              <FormControlLabel
                value="Brasileiro(a)"
                control={<Radio required />}
                label="Brasileiro(a)"
              />
              <FormControlLabel
                value="Outro(a)"
                control={<Radio required />}
                label="Outra"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        {form.dadosPessoais?.nacionalidade === "Outro(a)" && (
          <>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="xablaw"
                required
                fullWidth
                label=" Insira sua nacionalidade"
                inputProps={{ maxLength: 200 }}
                onChange={(e) =>
                  setForm({
                    ...form,
                    dadosPessoais: {
                      ...form.dadosPessoais,
                      nacionalidadeOutro: e.target.value,
                    },
                  })
                }
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="xablaw"
                required
                fullWidth
                label="Documento de identifcação"
                inputProps={{ maxLength: 200 }}
                onChange={(e) =>
                  setForm({
                    ...form,
                    dadosPessoais: {
                      ...form.dadosPessoais,
                      documentoDeIdentifcacao: e.target.value,
                    },
                  })
                }
              />
            </Grid>
          </>
        )}

        {form.dadosPessoais?.nacionalidade === "Brasileiro(a)" && (
          <>
            <Grid item xs={12}>
              <InputMask
                mask="999.999.999-99"
                inputProps={{ inputMode: "numeric" }}
                autoComplete="xablaw"
                required
                fullWidth
                label="CPF"
                value={form?.dadosPessoais.cpf || ""}
                onBlur={(e) => {
                  handleCPF(e.target.value);
                }}
                onChange={(e) =>
                  setForm({
                    ...form,
                    dadosPessoais: {
                      ...form.dadosPessoais,
                      cpf: e.target.value,
                    },
                  })
                }
              >
                {(inputProps) => <TextField {...inputProps} />}
              </InputMask>
            </Grid>
          </>
        )}

        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            type="email"
            inputProps={{ maxLength: 50 }}
            label="E-mail"
            autoComplete="xablaw"
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: { ...form.dadosPessoais, email: e.target.value },
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            type="date"
            InputLabelProps={{ shrink: true }}
            autoComplete="xablaw"
            label="Data de Nascimento"
            value={form?.dadosPessoais.dataNascimento}
            onBlur={(e) => handleDataNascimento(e.target.value)}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  dataNascimento: e.target.value,
                },
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputMask
            mask="(99) 99999-9999"
            maskChar=""
            inputProps={{ inputMode: "numeric" }}
            autoComplete="xablaw"
            required
            fullWidth
            label="Telefone"
            value={form?.dadosPessoais.telefone || ""}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  telefone: e.target.value,
                },
              })
            }
            onBlur={() =>
              form.dadosPessoais.telefone.length < 15
                ? setForm({
                    ...form,
                    dadosPessoais: { ...form.dadosPessoais, telefone: "" },
                  })
                : null
            }
          >
            {(inputProps) => <TextField {...inputProps} />}
          </InputMask>

          <FormControlLabel
            label="Este telefone é meu WhatsApp"
            control={
              <Switch
                onChange={(e) =>
                  setForm({
                    ...form,
                    dadosPessoais: {
                      ...form.dadosPessoais,
                      whatsapp: e.target.checked,
                    },
                  })
                }
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            type={showPassword ? "text" : "password"}
            inputProps={{ maxLength: 50 }}
            label="Senha"
            autoComplete="xablaw"
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: { ...form.dadosPessoais, senha: e.target.value },
              })
            }
            value={form?.dadosPessoais.senha || ""}
            onBlur={() => checkSenha(form.dadosPessoais.senha)}
            InputProps={{
              endAdornment: (
                <IconButton onClick={togglePasswordVisibility} edge="end">
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            type={showPassword ? "text" : "password"}
            inputProps={{ maxLength: 50 }}
            label="Confirmação de Senha"
            autoComplete="xablaw"
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  confirmacaoSenha: e.target.value,
                },
              })
            }
            value={form?.dadosPessoais.confirmacaoSenha || ""}
            onBlur={() =>
              validaSenha(
                form.dadosPessoais.senha,
                form.dadosPessoais.confirmacaoSenha
              )
            }
            InputProps={{
              endAdornment: (
                <IconButton onClick={togglePasswordVisibility} edge="end">
                  {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                </IconButton>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
            A senha deverá conter oito dígitos, ao menos um número, uma letra
            maiúscula e um caractere especial (+ - [ ] * ~ _ @ # :?) e não pode
            conter espaços.
          </Typography>
        </Grid>
      </Grid>
    </>
  );

  const dadosDoResponsavel = (
    <>
      <Grid container spacing={2}>
        <ChipDivider label="Responsável" />

        <Grid item xs={12}>
          <TextField
            autoComplete="xablaw"
            required
            fullWidth
            label="Nome Completo do Responsável"
            inputProps={{ maxLength: 200 }}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  dadosDoResponsavel: {
                    ...form.dadosPessoais.dadosDoResponsavel,
                    nomeCompleto: e.target.value,
                  },
                },
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputMask
            mask="999.999.999-99"
            inputProps={{ inputMode: "numeric" }}
            autoComplete="xablaw"
            required
            fullWidth
            label="CPF do seu responsável"
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  dadosDoResponsavel: {
                    ...form.dadosPessoais.dadosDoResponsavel,
                    cpf: e.target.value,
                  },
                },
              })
            }
          >
            {(inputProps) => <TextField {...inputProps} />}
          </InputMask>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Grau de Parentesco</InputLabel>
            <Select
              label="Grau de Parentesco"
              value={
                form?.dadosPessoais.dadosDoResponsavel.grauDeParentesco || ""
              }
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosPessoais: {
                    ...form.dadosPessoais,
                    dadosDoResponsavel: {
                      ...form.dadosPessoais.dadosDoResponsavel,
                      grauDeParentesco: e.target.value,
                    },
                  },
                })
              }
            >
              <MenuItem value="Pai">Pai</MenuItem>
              <MenuItem value="Mãe">Mãe</MenuItem>
              <MenuItem value="Avô">Avô</MenuItem>
              <MenuItem value="Avó">Avó</MenuItem>
              <MenuItem value="Outro">Outro</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {form.dadosPessoais.dadosDoResponsavel.grauDeParentesco === "Outro" && (
          <Grid item xs={12}>
            <TextField
              autoComplete="xablaw"
              required
              fullWidth
              label="Qual?"
              inputProps={{ maxLength: 200 }}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosPessoais: {
                    ...form.dadosPessoais,
                    dadosDoResponsavel: {
                      ...form.dadosPessoais.dadosDoResponsavel,
                      qualGrauDeParentesco: e.target.value,
                    },
                  },
                })
              }
            />
          </Grid>
        )}
      </Grid>
    </>
  );

  const endereco = (
    <>
      <Grid container spacing={2}>
        <ChipDivider label="Endereço" />
        <Grid item xs={12}>
          <InputMask
            mask="99999-999"
            inputProps={{ inputMode: "numeric" }}
            autoComplete="xablaw"
            required
            fullWidth
            label="CEP"
            value={form?.dadosPessoais.endereco.cep || ""}
            onBlur={checkCep}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  endereco: {
                    ...form.dadosPessoais.endereco,
                    cep: e.target.value,
                  },
                },
              })
            }
          >
            {(inputProps) => <TextField {...inputProps} />}
          </InputMask>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required>
            <InputLabel>Estado</InputLabel>
            <Select
              label="Estado"
              value={form?.dadosPessoais.endereco.estado || ""}
              disabled={!estados}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosPessoais: {
                    ...form.dadosPessoais,
                    endereco: {
                      ...form.dadosPessoais.endereco,
                      estado: e.target.value,
                      cidade: "",
                    },
                  },
                })
              }
            >
              {estados &&
                estados
                  .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"))
                  .map((estado) => (
                    <MenuItem key={estado.id} value={estado.sigla}>
                      {estado.nome}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required>
            <InputLabel>Cidade</InputLabel>
            <Select
              label="Cidade"
              value={form?.dadosPessoais.endereco.cidade || ""}
              disabled={!form?.dadosPessoais.endereco.estado}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosPessoais: {
                    ...form.dadosPessoais,
                    endereco: {
                      ...form.dadosPessoais.endereco,
                      cidade: e.target.value,
                    },
                  },
                })
              }
            >
              {cidades &&
                cidades
                  .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"))
                  .map((cidade) => (
                    <MenuItem key={cidade.id} value={cidade.nome}>
                      {cidade.nome}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            autoComplete="xablaw"
            required
            fullWidth
            value={form?.dadosPessoais.endereco.rua || ""}
            label="Endereço/Rua/Avenida"
            inputProps={{ maxLength: 200 }}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  endereco: {
                    ...form.dadosPessoais.endereco,
                    rua: e.target.value,
                  },
                },
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            autoComplete="xablaw"
            required
            fullWidth
            value={form?.dadosPessoais.endereco.bairro || ""}
            label="Bairro"
            inputProps={{ maxLength: 200 }}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  endereco: {
                    ...form.dadosPessoais.endereco,
                    bairro: e.target.value,
                  },
                },
              })
            }
          />
        </Grid>

        {/* <Grid item xs={12} sm={6}>
        <TextField
          required
          autoComplete="xablaw" fullWidth
          label="Número" inputProps={{ maxLength: 200 }}
          onChange={(e) => setForm({
            ...form,
            dadosPessoais: { ...form.dadosPessoais, endereco: { ...form.dadosPessoais.endereco, numero: e.target.value } }
          })}
        />
      </Grid> */}

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            required={!semNumero}
            autoComplete="xablaw"
            label={semNumero ? "Sem número" : "Número"}
            inputProps={{ maxLength: 200 }}
            value={form.dadosPessoais.endereco.numero}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  endereco: {
                    ...form.dadosPessoais.endereco,
                    numero: e.target.value,
                  },
                },
              })
            }
            disabled={semNumero}
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => {
                    setSemNumero(!semNumero);
                    setForm({
                      ...form,
                      dadosPessoais: {
                        ...form.dadosPessoais,
                        endereco: {
                          ...form.dadosPessoais.endereco,
                          numero: "",
                        },
                      },
                    });
                  }}
                  edge="end"
                >
                  {semNumero ? <AddCircleIcon /> : <RemoveCircleIcon />}
                </IconButton>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            autoComplete="xablaw"
            fullWidth
            value={form?.dadosPessoais.endereco.complemento || ""}
            label="Complemento"
            inputProps={{ maxLength: 200 }}
            onChange={(e) =>
              setForm({
                ...form,
                dadosPessoais: {
                  ...form.dadosPessoais,
                  endereco: {
                    ...form.dadosPessoais.endereco,
                    complemento: e.target.value,
                  },
                },
              })
            }
          />
        </Grid>
      </Grid>
    </>
  );

  const dadosSociodemograficos = (
    <>
      <Grid container spacing={2}>
        <ChipDivider label="Sociodemográficos" />
        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Como se identifca em relação ao seu gênero?</InputLabel>
            <Select
              label="Como se identifca em relação ao seu gênero?"
              value={form?.dadosSociodemograficos.genero || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    genero: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="Homem">Homem</MenuItem>
              <MenuItem value="Homem trans">Homem trans</MenuItem>
              <MenuItem value="Mulher">Mulher</MenuItem>
              <MenuItem value="Mulher trans">Mulher trans</MenuItem>
              <MenuItem value="Prefro não informar">
                Prefro não informar
              </MenuItem>
              <MenuItem value="Outro">Outro</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {form.dadosSociodemograficos.genero === "Outro" && (
          <Grid item xs={12}>
            <TextField
              autoComplete="xablaw"
              required
              fullWidth
              label="Qual?"
              inputProps={{ maxLength: 200 }}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    generoOutro: e.target.value,
                  },
                })
              }
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel>
              Como se identifca em relação a sua raça/etnia?
            </InputLabel>
            <Select
              label="Como se identifca em relação a sua raça/etnia?"
              value={form?.dadosSociodemograficos.raca || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    raca: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="Amarela">Amarela</MenuItem>
              <MenuItem value="Branca">Branca</MenuItem>
              <MenuItem value="Indígena">Indígena</MenuItem>
              <MenuItem value="Parda">Parda</MenuItem>
              <MenuItem value="Preta/Negra">Preta/Negra</MenuItem>
              <MenuItem value="Prefiro não informar">
                Prefiro não informar
              </MenuItem>
              <MenuItem value="Outro">Outro</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {form.dadosSociodemograficos.raca === "Outro" && (
          <Grid item xs={12}>
            <TextField
              autoComplete="xablaw"
              required
              fullWidth
              label="Qual?"
              inputProps={{ maxLength: 200 }}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    racaOutro: e.target.value,
                  },
                })
              }
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Você se identifca como LGBTQIAPN+?</InputLabel>
            <Select
              label="Você se identifca como LGBTQIAPN+?"
              value={form?.dadosSociodemograficos.lgbt || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    lgbt: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="Sim">Sim</MenuItem>
              <MenuItem value="Não">Não</MenuItem>
              <MenuItem value="Prefiro não informar">
                Prefiro não informar
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
            A sigla LGBTQIAPN+ representa pessoas que são Lésbicas, Gays,
            Bissexuais, Transexuais, Queer, Intersexo, Assexuais, Pansexuais e
            Não-binárias.
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required>
            <InputLabel>Você é uma pessoa com deficiência?</InputLabel>
            <Select
              label="Você é uma pessoa com defciência?"
              value={form?.dadosSociodemograficos.deficiencia || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    deficiencia: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="Não">Não</MenuItem>
              <MenuItem value="Sim, defciência auditiva">
                Sim, defciência auditiva
              </MenuItem>
              <MenuItem value="Sim, defciência visual">
                Sim, defciência visual
              </MenuItem>
              <MenuItem value="Sim, defciência física">
                Sim, defciência física
              </MenuItem>
              <MenuItem value="Sim, defciência intelectual">
                Sim, defciência intelectual
              </MenuItem>
              <MenuItem value="Sim, deficiência múltipla">
                Sim, deficiência múltipla
              </MenuItem>
              <MenuItem value="Prefiro não informar">
                Prefiro não informar
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth required>
            <InputLabel>Você se considera refugiado?</InputLabel>
            <Select
              label="Você se considera refugiado?"
              value={form?.dadosSociodemograficos.refugiado || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    refugiado: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="Sim">Sim</MenuItem>
              <MenuItem value="Não">Não</MenuItem>
              <MenuItem value="Prefiro não informar">
                Prefiro não informar
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
            Refugiado/a é a pessoa que está “fora de seu país de origem devido a
            fundados temores de perseguição relacionados a questões de raça,
            religião, nacionalidade, pertencimento a um determinado grupo social
            ou opinião política, como também devido à grave e generalizada
            violação de direitos humanos e confitos armados”, segundo a ACNUR,
            Agência da ONU para Refugiados.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Você faz parte de um povo indígena?</InputLabel>
            <Select
              label="Você faz parte de um povo indígena?"
              value={form?.dadosSociodemograficos.indigena || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    indigena: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="Sim">Sim</MenuItem>
              <MenuItem value="Não">Não</MenuItem>
              <MenuItem value="Prefiro não informar">
                Prefiro não informar
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel>
              Você faz parte de uma Comunidade Tradicional (quilombola, caiçara,
              etc.)?
            </InputLabel>
            <Select
              label="Você faz parte de uma Comunidade Tradicional (quilombola, caiçara, etc.)?"
              value={form?.dadosSociodemograficos.comunidadeTradicional || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    comunidadeTradicional: e.target.value,
                  },
                })
              }
            >
              <MenuItem value="Sim">Sim</MenuItem>
              <MenuItem value="Não">Não</MenuItem>
              <MenuItem value="Prefiro não informar">
                Prefiro não informar
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {form.dadosSociodemograficos.comunidadeTradicional === "Sim" && (
          <Grid item xs={12}>
            <TextField
              autoComplete="xablaw"
              required
              fullWidth
              label="Por favor, informe sua comunidade de residência"
              inputProps={{ maxLength: 200 }}
              onChange={(e) =>
                setForm({
                  ...form,
                  dadosSociodemograficos: {
                    ...form.dadosSociodemograficos,
                    comunidadeResidencia: e.target.value,
                  },
                })
              } 
            />
          </Grid>
        )}
      </Grid>
    </>
  );

  const escolaAluno = (
    <>
      <Grid container spacing={2}>
        <ChipDivider label="Escola" />

        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel>Estado da escola</InputLabel>
            <Select
              label="Estado da escola"
              value={form?.escola.estado || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  escola: {
                    ...form.escola,
                    estado: e.target.value,
                    municipio: "",
                    nomeDaEscola: "",
                  },
                })
              }
            >
              {estadosEscolas &&
                estadosEscolas
                  .sort((a, b) => a.localeCompare(b, "pt-BR"))
                  .map((estado) => (
                    <MenuItem key={estado} value={estado}>
                      {estado}
                    </MenuItem>
                  ))}

            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Autocomplete
            disablePortal
            disableClearable
            options={municipios}
            disabled={municipios.length === 0}
            value={form?.escola.municipio || ""}
            onChange={(e, newValue) =>
              setForm({
                ...form,
                escola: {
                  ...form.escola,
                  municipio: newValue || "", // Use newValue diretamente como o valor selecionado
                  nomeDaEscola: "",
                },
              })
            }
            getOptionLabel={(option) => option} // Função que define como exibir as opções no Autocomplete
            renderInput={(params) => (
              <TextField required {...params} label="Município da Escola" />
            )}
          />
        </Grid>


        <Grid item xs={12}>
          <Autocomplete
            disablePortal
            disableClearable
            options={escolas}
            disabled={escolas.length === 0}
            value={form?.escola.nomeDaEscola || ""}
            onChange={(e, v) =>
              setForm({
                ...form,
                escola: { ...form.escola, nomeDaEscola: v },
              })
            }
            renderInput={(params) => (
              <TextField required {...params} label="Nome da escola" />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography component="h1" variant="overline" sx={{ paddingY: 0 }}>
            Não encontrou a sua escola? Entre em contato com a gente através do
            E-mail:{" "}
            <Link
              to="#"
              sx={{ cursor: "pointer" }}
              onClick={(e) => {
                window.open("mailto:escolas@recode.org.br");
                e.preventDefault();
              }}
            >
              escolas@recode.org.br
            </Link>
          </Typography>
        </Grid>

        {/* {professores.length > 0 && (
          <>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Nome do(a) professor(a)</InputLabel>
                <Select
                  disabled={!form?.escola.nomeDaEscola}
                  label="Nome do(a) professor(a)"
                  value={form?.escola.nomeDoProfessor || ""}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      escola: {
                        ...form.escola,
                        nomeDoProfessor: e.target.value,
                      },
                    })
                  }
                >
                  <MenuItem key="0" value="Não encontro meu professor(a)">
                    Não encontro meu professor(a)
                  </MenuItem>
                  {professores.map((prof, i) => (
                    <MenuItem key={i} value={prof}>
                      {prof}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </>
        )} */}

        {/* {(professores.length === 0 ||
          form.escola.nomeDoProfessor === "Não encontro meu professor(a)") && (
          <Grid item xs={12}>
            <TextField
              disabled={!form?.escola.nomeDaEscola}
              autoComplete="xablaw"
              fullWidth
              label="Nome do(a) professor(a)"
              inputProps={{ maxLength: 200 }}
              onChange={(e) =>
                setForm({
                  ...form,
                  escola: {
                    ...form.escola,
                    nomeDoProfessorOutro: e.target.value,
                  },
                })
              }
            />
          </Grid>
        )} */}

        {/* <Grid item xs={12}>
          <Typography component="h1" variant="overline" sx={{ paddingY: 0 }}>
            Caso tenha sido convidado por um(a) professor(a), selecione o nome
            dele(a) na lista acima. Se estiver se inscrevendo por conta própria,
            deixe em branco.
          </Typography>
        </Grid> */}
      </Grid>
    </>
  );

  const escolaMEE = (
    <>
      <Grid container spacing={2}>
        <ChipDivider label="Escola" />

        <Grid item xs={12}>
        <FormControl fullWidth required>
            <InputLabel>Estado da escola</InputLabel>
            <Select
              label="Estado da escola"
              value={form?.escola.estado || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  escola: {
                    ...form.escola,
                    estado: e.target.value,
                    municipio: "",
                    nomeDaEscola: "",
                  },
                })
              }
            >
              {estadosEscolas &&
                estadosEscolas
                  .sort((a, b) => a.localeCompare(b, "pt-BR"))
                  .map((estado) => (
                    <MenuItem key={estado} value={estado}>
                      {estado}
                    </MenuItem>
                  ))}

            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Autocomplete
            disablePortal
            disableClearable
            options={municipios}
            disabled={municipios.length === 0}
            value={form?.escola.municipio || ""}
            onChange={(e, newValue) =>
              setForm({
                ...form,
                escola: {
                  ...form.escola,
                  municipio: newValue || "", // Use newValue diretamente como o valor selecionado
                  nomeDaEscola: "",
                },
              })
            }
            getOptionLabel={(option) => option} // Função que define como exibir as opções no Autocomplete
            renderInput={(params) => (
              <TextField required {...params} label="Município da Escola" />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Autocomplete
            disablePortal
            disableClearable
            options={escolas}
            disabled={escolas.length === 0}
            value={form?.escola.nomeDaEscola || ""}
            onChange={(e, v) =>
              setForm({
                ...form,
                escola: { ...form.escola, nomeDaEscola: v },
              })
            }
            renderInput={(params) => (
              <TextField required {...params} label="Nome da escola" />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography component="h1" variant="overline" sx={{ paddingY: 0 }}>
            Não encontrou a sua escola? Entre em contato com a gente através do
            E-mail:{" "}
            <Link
              to="#"
              sx={{ cursor: "pointer" }}
              onClick={(e) => {
                window.open("mailto:escolas@recode.org.br");
                e.preventDefault();
              }}
            >
              escolas@recode.org.br
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </>
  );

  const blocoTermos = (
    <>
      <Grid container spacing={2}>
        <ChipDivider label="Termos" />
      </Grid>
      {termos
        .sort((a, b) =>
          a.obrigatorio > b.obrigatorio
            ? 1
            : b.obrigatorio > a.obrigatorio
            ? -1
            : 0
        )
        .map((termo, index) => (
          <Grid item xs={12} key={index}>
            <FormControlLabel
              required={termo.obrigatorio}
              control={
                <Checkbox
                  checked={form?.termos?.[termo?.nome] || false}
                  onChange={(e) => {
                    setForm({
                      ...form,
                      termos: {
                        ...form.termos,
                        [termo.nome]: e.target.checked,
                      },
                    });
                  }}
                />
              }
              label={
                <span>
                  {termo.descricao + " "}
                  {termo.link && (
                    <Link
                      rel="noopener noreferrer"
                      href={termo.link}
                      target="_blank"
                    >
                      <OpenInNewIcon />
                    </Link>
                  )}
                </span>
              }
            />
          </Grid>
        ))}
    </>
  );

  const funcaoNaEscola = (
    <>
      <Grid container spacing={2}>
        <ChipDivider label="Função na Escola" />

        <Grid item xs={12}>
          <FormControl fullWidth required>
            <InputLabel>
              Por favor, indique qual a sua função na Escola
            </InputLabel>
            <Select
              label="Por favor, indique qual a sua função na Escola"
              value={form?.funcaoNaEscola.funcao || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  funcaoNaEscola: {
                    ...form.funcaoNaEscola,
                    funcao: e.target.value,
                    ministraAulas: [],
                  },
                })
              }
            >
              <MenuItem value="Professor(a)">Professor(a)</MenuItem>
              <MenuItem value="Monitor(a)">Monitor(a)</MenuItem>
              <MenuItem value="Coordenador(a)">Coordenador(a)</MenuItem>
              <MenuItem value="Diretor(a)">Diretor(a)</MenuItem>
              <MenuItem value="Outro(a)">Outro(a)</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {form?.funcaoNaEscola.funcao === "Outro(a)" && (
          <Grid item xs={12}>
            <TextField
              autoComplete="xablaw"
              required
              fullWidth
              label="Qual função?"
              inputProps={{ maxLength: 200 }}
              onChange={(e) =>
                setForm({
                  ...form,
                  funcaoNaEscola: {
                    ...form.funcaoNaEscola,
                    funcaoOutro: e.target.value,
                  },
                })
              }
            />
          </Grid>
        )}

        {form?.funcaoNaEscola.funcao === "Professor(a)" && (
          <>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  maxLength: 50,
                }}
                type="number"
                label="Atualmente, dá aula para quantas turmas?"
                autoComplete="xablaw"
                onChange={(e) =>
                  setForm({
                    ...form,
                    funcaoNaEscola: {
                      ...form.funcaoNaEscola,
                      quantidadeTurmas: e.target.value,
                    },
                  })
                }
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth required>
                <InputLabel>Você ministra aulas para...</InputLabel>
                <Select
                  value={form?.funcaoNaEscola.ministraAulas || []}
                  label="Você ministra aulas para..."
                  onChange={(e) => {
                    setForm({
                      ...form,
                      funcaoNaEscola: {
                        ...form.funcaoNaEscola,
                        ministraAulas: e.target.value,
                      },
                    });
                  }}
                  multiple
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                >
                  <MenuItem value="Ensino Médio" key="Ensino Médio">
                    Ensino Médio
                  </MenuItem>
                  <MenuItem value="EJA (Ensino Médio)" key="EJA (Ensino Médio)">
                    EJA (Ensino Médio)
                  </MenuItem>
                  <MenuItem value="Educação Infantil" key="Educação Infantil">
                    Educação Infantil
                  </MenuItem>
                  <MenuItem
                    value="Ensino Fundamental 1"
                    key="Ensino Fundamental 1"
                  >
                    Ensino Fundamental 1
                  </MenuItem>
                  <MenuItem
                    value="EJA (Ensino Fundamental 1)"
                    key="EJA (Ensino Fundamental 1)"
                  >
                    EJA (Ensino Fundamental 1)
                  </MenuItem>
                  <MenuItem
                    value="Ensino Fundamental 2"
                    key="Ensino Fundamental 2"
                  >
                    Ensino Fundamental 2
                  </MenuItem>
                  <MenuItem
                    value="EJA (Ensino Fundamental 2)"
                    key="EJA (Ensino Fundamental 2)"
                  >
                    EJA (Ensino Fundamental 2)
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
                É possível selecionar mais de uma resposta. Caso lecione em mais
                de uma etapa de ensino, por favor, selecione todas as que se
                aplicam.
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );

  const inscricao = (
    <>
      <Grid container spacing={2}>
        <ChipDivider label="Inscrição" />

        {contemElemento(
          ["Ensino Médio", "EJA (Ensino Médio)"],
          form?.funcaoNaEscola.ministraAulas
        ) && (
          <>
            <Grid item xs={12}>
              <FormControl fullWidth required>
                <InputLabel>
                  Por favor, indique em qual ou quais oportunidades você quer se
                  inscrever.
                </InputLabel>
                <Select
                  label="Por favor, indique em qual ou quais oportunidades você quer se inscrever."
                  value={form?.inscricao.qualOportunidade || ""}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      inscricao: {
                        ...form.inscricao,
                        qualOportunidade: e.target.value,
                      },
                    })
                  }
                >
                  <MenuItem value="2">
                    Quero me inscrever na trilha Reprogramando seu Futuro para
                    acompanhar meus alunos
                  </MenuItem>
                  {/* <MenuItem value="3">Quero me inscrever na formação O Papel dos Games na Aprendizagem</MenuItem>
                <MenuItem value="4">Quero me inscrever em ambas as oportunidades</MenuItem> */}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
                Ao selecionar uma opção, você será automaticamente inscrito
                na(s) oportunidade(s) selecionadas.
              </Typography>
            </Grid>
          </>
        )}

        {(["3", "4"].includes(form?.inscricao.qualOportunidade) ||
          !contemElemento(
            ["Ensino Médio", "EJA (Ensino Médio)"],
            form?.funcaoNaEscola.ministraAulas
          )) && (
          <>
            <Grid item xs={12}>
              <FormControl fullWidth required>
                <InputLabel>
                  Escolha o melhor dia e horário para participar da formação "O
                  Papel dos Games na Aprendizagem":
                </InputLabel>
                <Select
                  label='Escolha o melhor dia e horário para participar da formação "O Papel dos Games na Aprendizagem"'
                  value={form?.inscricao.melhorHorario || ""}
                  onChange={(e) => {
                    setForm({
                      ...form,
                      inscricao: {
                        ...form.inscricao,
                        melhorHorario: e.target.value,
                      },
                    });
                    if (
                      e.target.value ===
                      form?.inscricao.melhorHorarioAlternativo
                    )
                      return setForm({
                        ...form,
                        inscricao: {
                          ...form.inscricao,
                          melhorHorarioAlternativo: "",
                        },
                      });
                  }}
                >
                  {horarios.map((horario) => (
                    <MenuItem value={horario} key={horario}>
                      {horario}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
                Chegou a hora de escolher sua turma. A formação "O Papel dos
                Games na Aprendizagem" terá encontros UMA VEZ POR SEMANA,
                síncronos (ao vivo), pelo Microsoft Teams.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>
                  Por favor, indique uma segunda opção de dia e horário para
                  participar:
                </InputLabel>
                <Select
                  label="Por favor, indique uma segunda opção de dia e horário para participar:"
                  value={form?.inscricao.melhorHorarioAlternativo || ""}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      inscricao: {
                        ...form.inscricao,
                        melhorHorarioAlternativo: e.target.value,
                      },
                    })
                  }
                >
                  {horarios
                    .filter((f) => f !== form.inscricao.melhorHorario)
                    .map((horario) => (
                      <MenuItem value={horario} key={horario}>
                        {horario}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Typography component="h1" variant="caption" sx={{ paddingY: 0 }}>
                Caso só possa participar no dia e horário anteriormente
                escolhidos, deixe em branco.
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );

  const mensagemFinalizacao = {
    finalizacao1: (
      <>
        Obrigada pela sua inscrição! Você será redirecionado(a) para uma página
        onde poderá fazer seu primeiro login e acessar os conteúdos da formação.
        <br />
        Conte com o apoio do(a) seu(sua) professor(a) para acompanhá-lo(a) no
        processo, e lembre-se de concluir a trilha até dia 31 de agosto para
        participar do Ideathon Janelas e concorrer a prêmios incríveis!
        <br />
      </>
    ),
    finalizacao2: (
      <>
        Obrigada pela sua inscrição! Você será redirecionado(a) para uma página
        onde poderá fazer seu primeiro login e acessar os recursos necessários
        para acompanhar sua turma de alunos(as).
        <br />
        A partir de agora, já é possível inscrevê-los(as)! Indique a eles(as) o
        link https://recode.org.br/janelas-para-o-amanha/ ou auxilie-os(as)
        diretamente no processo de cadastramento. Lembre-se: professores(as) com
        30 ou mais alunos(as) concluintes até dia 31 de agosto concorrem a
        prêmios incríveis!
        <br />
      </>
    ),
    finalizacao3: (
      <>
        Obrigada pela sua inscrição! Você será redirecionado para uma página
        onde poderá fazer seu primeiro login e acessar os conteúdos e
        informações relacionados à formação "O Papel dos Games na Aprendizagem".
        <br />
      </>
    ),
    finalizacao4: (
      <>
        Obrigada pela sua inscrição! Você será redirecionado para uma página
        onde poderá fazer seu primeiro login e acessar os conteúdos e
        informações relacionados à formação "O Papel dos Games na Aprendizagem"
        e também acessar os recursos necessários para acompanhar sua turma de
        alunos(as).
        <br />
        A partir de agora, já é possível inscrevê-los(as)! Indique a eles(as) o
        link https://recode.org.br/janelas-para-o-amanha/ ou auxilie-os(as)
        diretamente no processo de cadastramento. Lembre-se: professores(as) com
        30 ou mais alunos(as) concluintes até dia 31 de agosto concorrem a
        prêmios incríveis!
        <br />
      </>
    ),
    finalizacao5: (
      <>
        Obrigada pela sua inscrição! Você será redirecionado para a página
        inicial da formação "O Papel dos Games na Aprendizagem", onde poderá
        conferir todas as informações sobre o curso
      </>
    ),
  };

  function obterMensagemAlerta(perfil, qualOportunidade) {
    return mensagemFinalizacao.finalizacao5;

    // if (perfil === "Aluno") {
    //   return mensagemFinalizacao.finalizacao1;
    // }

    // if (perfil === "MEE") {
    //   if (qualOportunidade === "2") {
    //     return mensagemFinalizacao.finalizacao2;
    //   }

    //   if (qualOportunidade === "3" || qualOportunidade === "") {
    //     return mensagemFinalizacao.finalizacao3;
    //   }

    //   if (qualOportunidade === "4") {
    //     return mensagemFinalizacao.finalizacao4;
    //   }
    // }
  }

  const redirect = () =>
    window.location.replace("https://escolas.recode.org.br/login");

  const dialog = (
    <>
      <Dialog
        open={open}
        keepMounted
        // onClose={() => redirect()}
        onClose={redirect}
      >
        <DialogTitle>Sucesso!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {obterMensagemAlerta(form.perfil, form.inscricao.qualOportunidade)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={() => redirect()}>Concluir</Button> */}
          <Button onClick={redirect}>Concluir</Button>
        </DialogActions>
      </Dialog>
    </>
  );

  function submit(form) {
    let perfil;
    switch (form.perfil) {
      case "Aluno":
        perfil = "Aluno";
        break;
      case "MEE":
        perfil = "MembroEquipeEscolar";
        break;
      default:
        break;
    }

    const request = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/api/Janelas/CadastroJanelas/${perfil}`,
      request
    )
      .then((response) => response.json())
      .then((data) => {
        console.warn(data);
        if (data.success) {
          setOpen(true);
        } else {
          Toast.fire({
            icon: "error",
            // title: "Um erro ocorreu, verifique os dados e tente novamente mais tarde.",
            title: data.message,
          });
        }
      })
      .finally(() => setLoading(false));
  }

  const handleForm = (e) => {
    e.preventDefault();
    setLoading(true);

    let body = { ...form, termos: termosParaEnviar(form.termos) };

    submit(body);
  };

  async function submitWidget() {
    setIsWidgetLoading(true);
    console.log(widgetForm);
    await fetch(
      `${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/DispararEmail`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nomeRementente: widgetForm.nome,
          emailRemetente: widgetForm.email,
          projeto: widgetForm.projeto,
          assunto: widgetForm.assunto,
          corpo: widgetForm.corpo,
        }),
      }
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          Toast.fire({
            icon: "success",
            title: "Sua mensagem foi enviada com sucesso!",
          });
          setWidgetForm({
            nome: "",
            email: "",
            assunto: "",
            projeto: "QOT",
            corpo: "",
          });
        } else {
          Toast.fire({
            icon: "warning",
            title: "Espere alguns instantes para enviar uma nova mensagem.",
          });
        }
      })
      .catch((error) => {
        console.log("error", error);
        Toast.fire({ icon: "Erro", title: "Um erro ocorreu!" });
      })
      .finally(() => {
        setIsWidgetLoading(false);
        setWidgetIsOpen(false);
      });
  }

  const [isWidgetLoading, setIsWidgetLoading] = useState(false);
  const [widgetForm, setWidgetForm] = useState({
    nome: "",
    email: "",
    assunto: "",
    projeto: "CadastroJanelas",
    corpo: "",
  });

  return (
    <ThemeProvider theme={lightTheme}>
      <Widget
        content={
          <form
            style={{ display: "flex", gap: "5px", flexDirection: "column" }}
            onSubmit={(e) => {
              e.preventDefault();
              submitWidget();
            }}
          >
            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Nome"
                value={widgetForm.nome}
                onChange={(e) =>
                  setWidgetForm({ ...widgetForm, nome: e.target.value })
                }
              />
            </InputArea>

            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Email"
                type="email"
                placeholder="estudante@email.com"
                value={widgetForm.email}
                onChange={(e) =>
                  setWidgetForm({ ...widgetForm, email: e.target.value })
                }
              />
            </InputArea>

            <InputArea>
              <Select
                disabled={isWidgetLoading}
                className={styles.select}
                required
                label="Assunto"
                onChange={(e) =>
                  setWidgetForm({ ...widgetForm, assunto: e.target.value })
                }
              >
                <option>Elogio</option>
                <option>Dúvida</option>
                <option>Cadastro</option>
                <option>Problema técnico</option>
                <option>Outro</option>
              </Select>
            </InputArea>

            <InputArea>
              <textarea
                disabled={isWidgetLoading}
                className={styles.textarea}
                required
                rows={5}
                placeholder="Sua mensagem"
                value={widgetForm.corpo}
                onChange={(e) =>
                  setWidgetForm({ ...widgetForm, corpo: e.target.value })
                }
              ></textarea>
            </InputArea>

            <InputArea>
              <ContainedBtn
                className={styles.submitBtn}
                disabled={isWidgetLoading}
              >
                {" "}
                {!isWidgetLoading ? "Enviar" : "Enviando..."}{" "}
              </ContainedBtn>
            </InputArea>
          </form>
        }
      />
      <CssBaseline />
      <HelmetThemeColor color="#008542" />
      <Container maxWidth="md" sx={{ paddingY: 3 }}>
        <form
          onSubmit={handleForm}
          autoComplete="off"
          // noValidate
        >
          <Box
            sx={{
              ...box,
              alignItems: "center",
            }}
          >
            {header}
          </Box>

          <Box sx={box}>{inicio}</Box>

          {form.perfil && (
            <>
              <Box sx={box}>{dadosPessoais}</Box>

              {idade < 18 && <Box sx={box}>{dadosDoResponsavel}</Box>}

              <Box sx={box}>{endereco}</Box>

              <Box sx={box}>{dadosSociodemograficos}</Box>

              {form.perfil === "Aluno" && (
                <>
                  <Box sx={box}>{escolaAluno}</Box>
                </>
              )}

              {form.perfil === "MEE" && (
                <>
                  <Box sx={box}>{escolaMEE}</Box>

                  <Box sx={box}>{funcaoNaEscola}</Box>

                  {/* {form?.funcaoNaEscola.funcao && (
                    <Box sx={box}>{inscricao}</Box>
                  )} */}
                </>
              )}

              <Box sx={box}>{blocoTermos}</Box>

              <Box sx={box}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2, p: 1 }}
                  disabled={loading}
                >
                  {!loading ? (
                    "Cadastrar"
                  ) : (
                    <CircularProgress color="secondary" size={22} />
                  )}
                </Button>
              </Box>
            </>
          )}

          {/* <Box
            xs={12}
            sx={{
              paddingTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src={regua}
              alt="régua de logos"
              style={{ maxWidth: "100%" }}
            />
          </Box> */}
        </form>
        {dialog}
      </Container>
    </ThemeProvider>
  );
}
